import React from 'react';
import { useQuery } from '@apollo/client';
import WearableProvidersQuery from './WearableProvidersQuery';
import type { WearableProvider } from '../types';

interface Result {
  loading: boolean;
  error: boolean;
  providers: WearableProvider[];
  refetch: () => void;
}

interface Props {
  children: (result: Result) => React.ReactElement;
}

const WearableProvidersConnectorApollo: React.FC<Props> = ({ children }) => {
  const { loading, data, error, refetch } = useQuery<{ wearableProviders: WearableProvider[] }>(
    WearableProvidersQuery,
    {
      fetchPolicy: 'cache-and-network',
    }
  );

  return children({
    loading,
    error: Boolean(error),
    providers: data?.wearableProviders ?? [],
    refetch,
  });
};

export default WearableProvidersConnectorApollo;
